import { useLocation } from '@reach/router';
import React, { useEffect } from 'react';
import { Redux, Slices } from 'spwa-ui-library';

const { useSelector, useDispatch } = Redux;
const { getOrderInvoice } = Slices.orderSlice;
const { fetchConfig } = Slices.configSlice;
const IFrame = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const orderInvoiceData = useSelector((state) => state?.order?.orderInvoice);
  const blobURL = useSelector((state) => state?.config?.data?.data.paymentFailureUrl);
  // console.log(blobURL, 'blob');
  let domain = new URL(blobURL);
  // domain = domain.hostname;
  // console.log(domain);
  const search = new URLSearchParams(location.search);
  const orderid = search.get('orderId') || '';
  const type = search.get('orderType') || '';

  const url = `${domain.protocol}//${domain.hostname}/log-service/v3/order/invoice?orderId=${orderid}&type=${type}`;
  return (
    <div className="heyBoss">
      <iframe
        src={url}
        title="Order Invoice"
        style={{
          border: 0,
          position: 'fixed',
          left: 0,
          top: 0,
          height: '100vh',
          width: '100vw',
        }}
      />
    </div>
  );
};
export default IFrame;

//   <embed
//   src={orderInvoiceData?.info?.file}
//   id="displayFile"
//   alt="your image"
//   width="100%"
//   height="99%"
//   style={{ borderStyle: 'solid' }}
//   type="application/pdf"
// />
